import { AnimationPanelDef } from './AnimationPanelDef';
import { AudioElement } from './AudioElement';
import { C9Object } from './C9Object';
import { C9SceneDefProperties } from './C9SceneDefProperties';
import { ForecastWDElementDef } from './ForecastWDElementDef';
import { ImagePanelDef } from './ImagePanelDef';
import { LogicalGroupElement } from './LogicalGroupElement';
import { MapPanelDef } from './MapPanelDef';
import { ObservedWDElementDef } from './ObservedWDElementDef';
import { PointDateDef } from './PointDateDef';
import { PointLocationDef } from './PointLocationDef';
import { TextPanelDef } from './TextPanelDef';
import { TimeControlDef } from './TimeControlDef';
import { VideoPanelDef } from './VideoPanelDef';
import { WeatherPosterDef } from './WeatherPosterDef';

export class SceneDef extends C9Object {
  videoPanels: VideoPanelDef[];
  imagePanels: ImagePanelDef[];
  mapPanels: MapPanelDef[];
  textPanels: TextPanelDef[];
  mapTextPanels: TextPanelDef[];
  weatherPosters: WeatherPosterDef[];
  audioElements: AudioElement[];
  animationPanels: AnimationPanelDef[];
  observedWDElements: ObservedWDElementDef[];
  forecastWDElements: ForecastWDElementDef[];
  pointDates: PointDateDef[];
  pointLocation: PointLocationDef[];
  logicalGroups: LogicalGroupElement[];
  durationInMS: number;
  c9SceneDefProperties: C9SceneDefProperties[];
  thumbnailUrls: Array<string>;
  timeControl: TimeControlDef;
  translationId: string | null;
  //fe only
  hold = 3000;
  repeat = 1;
  helperId?: string | null;
}
